<div class="topbar">
  <h1 class="topbar__logo">
    <a [routerLink]="'/'" class="logo-mvrdv color--black">
      <app-icon class="logo" [anchor]="'logo'"></app-icon>
      <span class="is--hidden">MVRDV &nbsp;</span>
      <span class="logo-sub ">{{ titleLogo }}</span>
    </a>
  </h1>
  <nav class="topbar__nav">
    <button *ngIf="user && user.auth" class="topbar__nav-notifications" [matMenuTriggerFor]="appMenu">
      <div class="topbar__nav-notifications__badge">
        <mat-icon [matBadge]="unreadCount" [matBadgeHidden]="!unreadCount" matBadgeColor="warn" matBadgePosition="above after">
          <app-icon [anchor]="'icon-notification'"></app-icon>
        </mat-icon>
      </div>
    </button>

    <button
      *ngIf="user && user.auth"
      class="topbar__nav-user"
      [title]="user.name"
      [class.set--active]="profileActive"
      (click)="profileActive = !profileActive"
    >
      <figure *ngIf="user" class="topbar__nav-user__avatar">
        <img [src]="user.avatarUrl" *ngIf="user.avatarUrl" />
        <strong *ngIf="!user.avatarUrl">{{ user.name.charAt(0) }}</strong>
      </figure>
      <ul class="topbar__nav-user__list">
        <li class="topbar__nav-user__list-item">
          <a [routerLink]="['/employees/profile']">Profile</a>
        </li>
        <li class="topbar__nav-user__list-item">
          <a [routerLink]="['/change-password']">Change password</a>
        </li>
        <li class="topbar__nav-user__list-item">
          <a [routerLink]="['/signout']">Log out</a>
        </li>
      </ul>
    </button>
    <button class="topbar__nav__toggle-button" [class.is--active]="menuActive" (click)="toggle()">
      <span class="line"></span>
      <span class="line"></span>
      <span class="line"></span>
    </button>

    <app-menu (clickEvent)="toggle()"></app-menu>
  </nav>
</div>

<mat-menu #appMenu="matMenu" class="notification-menu">
  <mat-nav-list class="notification-menu__list">
    <a
      mat-list-item
      class="notification-menu__list__sender"
      *ngFor="let n of notifications"
      [class.is--read]="n.IsRead"
      [class.is--unread]="!n.IsRead"
      [routerLink]="n.RouterLink"
      (click)="NotificationClicked.emit(n)"
    >
      <!-- <img matListAvatar [src]="n.PrimarySender.portrait" [alt]="n.PrimarySender.name" /> -->

      <figure *ngIf="n.PrimarySender" class="notification-menu__list__sender-avatar">
        <img [src]="n.PrimarySender.portrait" *ngIf="n.PrimarySender.portrait" />
        <strong *ngIf="!n.PrimarySender.portrait">{{ n.PrimarySender.name.charAt(0) }}</strong>
      </figure>
      <figure *ngIf="!n.PrimarySender" class="notification-menu__list__sender-avatar">
        <img src="https://mvrdv.com/media/uploads/logo-square-180.png?width=80" />
      </figure>
      <div class="notification-menu__list__content">
        <div class="notification-menu__list__item-title" matLine>{{ n.Message }}</div>
        <p class="notification-menu__list__item-meta" matLine>
          <span>{{ n.Date | timeAgo }}</span>
        </p>
      </div>
    </a>
  </mat-nav-list>
  <div class="notify-toggle" *ngIf="!platform.SAFARI">
    <mat-slide-toggle
      class="notigy-toggle_slide"
      (change)="askPermission($event)"
      [checked]="($messagingToken | async) !== null"
      [color]="'primary'"
    >
      Push notifications
      {{ ($messagingToken | async) !== null ? 'enabled' : 'disabled' }}
    </mat-slide-toggle>
  </div>
  <!-- <a (click)="askPermission()" *ngIf="!($messagingToken | async)">
    <mat-icon>check_box_outline_blank</mat-icon>
    push notifications disabled
  </a>
  <a (click)="removePermission(token)" *ngIf="$messagingToken | async as token">
    <mat-icon>check_box</mat-icon>
    push notifications enabled
  </a> -->
</mat-menu>
